'use es6';

import { useCallback } from 'react';
import { useEditorComponents } from 'reporting-enablement/components/reportEditors/common/useEditorComponents';
import { EDITOR_TYPES } from 'reporting-data/tsTypes/editorTypes';
import { getBreakdownPropertiesForReport, hasBreakdownEditor } from '../../utils/salesAnalyticsHelpers';
import usageTracker from '../../utils/usageTracker';
import { deriveBreakdownFromReport } from '../../constants/sub-app/contextDefaults';
import { jsx as _jsx } from "react/jsx-runtime";
const SecondDimensionControl = ({
  report,
  subAppKey,
  updateContext
}) => {
  const breakdownDimensionsToProperties = getBreakdownPropertiesForReport(subAppKey);
  const breakdownProperties = Object.values(breakdownDimensionsToProperties);
  const handleChange = useCallback(updatedReport => {
    updateContext({
      breakdown: deriveBreakdownFromReport(updatedReport, subAppKey)
    }, report);
  }, [report, subAppKey, updateContext]);
  const editorSchema = {
    type: EDITOR_TYPES.BREAKDOWN,
    properties: breakdownProperties
  };
  const EditorComponents = useEditorComponents(report, [editorSchema]);
  if (EditorComponents.length === 0) {
    return null;
  }
  const EditorComponent = EditorComponents[0];
  return /*#__PURE__*/_jsx("div", {
    "data-sub-app-tour-step-id": "breakdownStep",
    children: /*#__PURE__*/_jsx(EditorComponent, {
      appUsageTracker: usageTracker,
      onChange: handleChange,
      report: report
    })
  });
};
SecondDimensionControl.isUsableForReport = ({
  subAppKey
}) => hasBreakdownEditor(subAppKey);
export default SecondDimensionControl;